import { RootState } from '@doda/common/src/redux/store';
import { Tab } from 'pages/DodaFront/View/JobSearchDetail/types/tab';

export const tabSelector = (state: RootState) =>
  state.queryParams.queryParams?.tab as Tab;
